<template>
  <div class="animated fadeIn">
      <b-card>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <b-form inline>
              <label for="opt_date">From </label>
                <date-picker style="width: 300px" v-model="From" :confirm="true" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <b-form inline>
              <label for="opt_date">To </label>
                <date-picker style="width: 300px" v-model="To" :confirm="true" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button size="sm" variant="primary" @click="report"> 검색 </b-button>
          <b-button size="sm" variant="secondary" @click="reset"> 초기화 </b-button>
          <b-button size="sm" variant="success" id="excelHtml5" @click="printNow"> PRINT </b-button>
        </b-form-group>
      </b-card>
      <div style="display:block; margin-left:auto; margin-right:auto;"><br>
      <h1 align="center" style="font-weight:700; font-size:50px">WMDS보고서</h1>
      </div>
      <img style="display:block; margin-left:auto; margin-right:auto;" src="../report/world_map.png"/>
      <b-card>
        <b-form-group>
        Copyrights<br><br>
        Copyright ⓒ 2019 F1Security Inc.<br>
        10F, #1003, 128, 가산 디지털 1로, 금천구, 서울특별시, 대한민국 (08507)<br>
        All Rights Reserved.<br><br>
        본 보고서는 ‘WMDS’ 담당자에게 해당기간 악성코드 점검 결과 정보를 제공하기 위해 작성되었습니다.<br>
        이 문서의 저작권은 ㈜에프원시큐리티에 있습니다. 저작권법에 의해 한국 내에서 보호 받는 저작물이므로
        어떠한 형태로든 무단전재와 무단복제를 금합니다.<br> 본 문서의 내용에 대해서 ㈜에프원시큐리티의 문서상의 동의 없이는,
        전체 혹은 부분적으로도 인용이 불가함을 알려드립니다. 동의 없이 사용할 시는 관련법에 의해 처벌 받을 수 있습니다.<br>
        이 문서에서는 기술적으로 부정확한 설명, 인쇄상의 잘못 등이 있을 가능성이 있습니다.
        ㈜에프원시큐리티에서는 예고 없이 이 문서의 내용 또는 프로그램을 수정 또는 변경할 수 있음을 양지 하시기 바랍니다.
        </b-form-group>
      </b-card>
       <b-form-group>
          <h4 style="page-break-before:always;">목차</h4>
        </b-form-group>
          <b-card>
            <b-form-group>
              1. 요약 - 기간 주요 내용 요약<br>
              1.1.{{model.name || 'WMDS'}}WMDS 정보<br>
              1.2. 점검 통계 정보<br>
              1.3. 등급별 탐지 사이트 검출 횟수 통계<br>
              1.4. 탐지사이트 정보<br>
              2. 상세 – 일간 단위 상세 내용<br>
              2.1. 점검 통계 정보<br>
              2.2. 전체 점검 내역 목록<br>
              2.3. 사이트 점검 횟수 통계<br>
              2.4. 등급별 탐지 사이트 검출 횟수<br>
              2.5. 탐지사이트 정보<br>
              2.6. 상태별 사이트 점검 결과<br>
              2.7. 위험등급 의심 목록<br>
            &lt;표 1. 사이트 기본 정보&gt;<br>
            &lt;표 2. 점검정책목록&gt;<br>
            &lt;표 3. 점검 통계 정보&gt;<br>
            &lt;표 4. 등급별 탐지 사이트 검출 통계표&gt;<br>
            &lt;표 5. 탐지사이트 정보&gt;<br>
            &lt;표 6. 점검 통계표&gt;<br>
            &lt;표 7. 전체 점검 내역 목록표&gt;<br>
            &lt;표 8. 사이트 점검 횟수 통계표&gt;<br>
            &lt;표 9. 등급별 탐지 사이트 검출 통계표&gt;<br>
            &lt;표 10. 탐지사이트 목록&gt;<br>
            &lt;표 11. 상태별 사이트 점검 통계표&gt;<br>
            &lt;표 12. 위험등급 의심 목록&gt;<br>
            &lt;그림 1. 점검 통계 그래프&gt;<br>
            &lt;그림 2. 사이트 점검 횟수 통계 그래프&gt;<br>
            &lt;그림 3. 등급별 탐지 사이트 검출 횟수 통계 그래프&gt;<br>
            &lt;그림 4. 상태별 사이트 점검 통계 그래프&gt;<br>
            </b-form-group>
          </b-card>
        <b-form-group>
          <h5>1. 요약 - 기간 주요 내용 요약</h5>
        </b-form-group>
         <b-form-group>
          <h5>1.1. 사용자 등록 사이트 정보</h5>
          <small>사용자 등록 사이트의 기본 정보입니다. 다음 &lt;표 1. 사이트 기본 정보&gt;를 통하여 사이트명, 업체명, 사이트 URL, FQDN, 관리자명, DNS정보, 등록 도메인 수(총 합계), 점검정책을 확인할 수 있습니다.</small>
        </b-form-group>
          <b-card>
            <template slot="header">
               &lt;표 1. 사이트 기본 정보&gt;
            </template>
            <div class="panel-body">
              <div>
                <table style="width:100%; max-width:100%; border:1px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center;">기업명</th>
                      <th style=" width:300px; padding:4px; background-Color:#f0f3f5; text-align: center;" v-if="model.user">{{model.user.groupname || 'WMDS'}}</th>
                      <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center;">등록도메인 수</th>
                      <th style=" width:300px; padding:4px; background-Color:#f0f3f5; text-align: center;" v-if="model.site">{{model.site.length || '0'}} 건</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card>
        <b-form-group>
          <h5>1.2. 점검 통계 정보</h5>
          <small>악성코드 점검 통계 정보입니다. 다음 &lt;표 3. 점검 통계 정보&gt;를 통하여 등록 도메인, 탐지 페이지 탐지 건수, 사이트 점검 횟수, 탐지룰 수를 확인할 수 있습니다.</small>
        </b-form-group>
        <b-card>
          <template slot="header">
             &lt;표 3. 점검 통계 정보&gt;
          </template>
          <div style="width:100%; min-height: .01%; display: block;">
            <table style="width:100%; max-width:100%; margin-bottom:20px; border-spacing: 0; border-collapse: collapse; border: 1px solid; text-align:center;">
              <tbody>
                <tr style="padding: 4px; background-Color: #ccc text-align: center;">
                  <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">등록 도메인</th>
                  <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">페이지 점검 건수</th>
                  <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">페이지 탐지 룰 분류</th>
                  <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">탐지 룰</th>
                </tr>
                <tr style="padding: 4px; background-Color: #ccc text-align: center;">
                  <td style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;" v-if="this.site.is_use"><b>( 총 : {{site.is_use + site.un_use}}건)</b></td>
                  <td style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;" v-if="!this.site.is_use"><b>( 총 : 0 건)</b></td>
                  <td style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;"><b>( 총 : {{result.total.page_count + result.total.ext_count + result.total.detect_count}} 건)</b></td>
                  <td style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">
                    <b>( 총 :  건)</b>
                  </td>
                  <td style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;"><b>( 총 : {{ model.rs_rule && model.rs_rule[0].U + model.rs_rule[0].S + model.rs_rule[0].M + model.rs_rule[0].R|number}} 건)</b></td>
                </tr>
                <tr class="right2">
                  <td style="border: 1px solid;" v-if="site.is_use">[사용중 : {{site.is_use}} 건]</td>
                  <td style="border: 1px solid;">[내부 페이지  : {{result.total.page_count}} 건]</td>
                  <td style="border: 1px solid;">[]</td>
                  <td style="border: 1px solid;">[]</td>
                </tr>
                <tr class="right2">
                  <td style="border: 1px solid;">[미사용 : {{site.un_use}} 건]</td>
                  <td style="border: 1px solid;">[외부 페이지 : {{result.total.ext_count}} 건]</td>
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                </tr>
                <tr class="right2">
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;">[탐지 페이지 : {{result.total.detect_count}} 건]</td>
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                </tr>
                <tr class="right2">
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                </tr>
                <tr class="right2">
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                </tr>
                <tr class="right2">
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-card>
       <b-form-group style="page-break-before:always;">
          <h5>1.3. 등급별 탐지 사이트 검출 횟수 통계</h5>
          <small>악성코드 점검 결과 등급별 탐지 사이트 검출 횟수 통계 정보입니다. 의심, 경고, 위험, 주의 등급별 탐지 사이트 검출 횟수를 확인할 수 있습니다.</small>
        </b-form-group>
        <b-card>
          <template slot="header">
            &lt;표 4. 등급별 탐지 사이트 검출 통계표&gt;
          </template>
          <div style="width:100%; min-height: .01%; display: block;">
            <table style="width:100%; max-width:100%; margin-bottom:20px; border-spacing: 0; border-collapse: collapse; border: 1px solid; text-align:center;">
              <tbody>
                <tr style="padding: 4px; background-Color: #ccc text-align: center;">
                  <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">기간</th>
                  <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">의심</th>
                  <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">경고</th>
                  <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">위험</th>
                  <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">주의</th>
                  <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">총</th>
                </tr>
                <tr>
                  <th style=" border: 1px solid; width:280px;">{{From|date}} ~ {{To|date}}</th>
                  <th style=" border: 1px solid;">{{model.rs_detect && model.rs_detect[0].S|number}}</th>
                  <th style=" border: 1px solid;">{{model.rs_detect && model.rs_detect[0].W|number}}</th>
                  <th style=" border: 1px solid;">{{model.rs_detect && model.rs_detect[0].H|number}}</th>
                  <th style=" border: 1px solid;">{{model.rs_detect && model.rs_detect[0].N|number}}</th>
                  <th style=" border: 1px solid;">{{model.rs_detect && model.rs_detect[0].H + model.rs_detect[0].W + model.rs_detect[0].S + model.rs_detect[0].N|number}}</th>
                </tr>
              </tbody>
            </table>
          </div>
        </b-card>
       <b-form-group>
        <h5>1.4. 탐지사이트 정보</h5>
        <small>의심 등급을 제외한 악성코드 점검 결과 악성코드에 탐지된 사이트 목록입니다.</small><br>
         <small>
         - 의심 : 악성코드는 존재하지 않으며, 자동으로 파일 다운로드 혹은 다른 페이지로 자동으로 relay 시키는 경우가 있어 주의가 필요함<br>
         - 경고 : 악성코드는 존재하지 않으나, 과거에 탐지된 이력이 있으며 위험성이 낮음<br>
         - 위험 : 악성코드는 존재하지 않으나, 최근에 탐지된 이력이 있으며 위험성이 있음<br>
         - 주의 : 악성코드를 유포할 위험성이 높은 상태임<br>
         </small>
      </b-form-group>
      <b-card>
      <template slot="header">
         &lt;표 5. 탐지사이트 정보&gt;
      </template>
      <b-table hover striped small responsive="sm"  ref="_ch5" show-empty empty-text="not found"
        :items="rs_ch5[1]" :fields="ch5" :current-page="1" :per-page="20" :sortBy="so.sk">
        <template slot="name" slot-scope="row">{{row.item.name}}</template>
        <template slot="detected_at" slot-scope="row">{{row.item.detected_at | date}}</template>
        <template slot="type" slot-scope="row">{{row.item.type}}</template>
        <!-- <template slot="level" slot-scope="row">{{row.item.level | code_level}}</template> -->
        <!-- <template slot="Date" slot-scope="row">{{row.item.Date}}</template> -->
      </b-table>
      </b-card>
      <b-form-group style="page-break-before:always;">
        <h5>2. 상세 – 일간 단위 상세 내용</h5>
      </b-form-group>
      <b-form-group>
        <h5>2.1. 점검 통계 정보</h5>
        <small>악성코드 점검 통계 정보입니다.</small>
      </b-form-group>
     <b-card>
      <template slot="header">
         &lt;그림 1. 점검 통계 그래프&gt;
      </template>
      <b-row>
        <b-col sm="6" lg="3">
          <h6 class="mb-0">등록 도메인</h6>
          <card-bar-chart class="chart-wrapper px-3" style="height:150px;" :options="bar_opt" :chart-data="use_data"/>
        </b-col>
        <b-col sm="6" lg="3">
          <h6 class="mb-0">페이지 점검 건수</h6>
          <card-bar-chart class="chart-wrapper px-3" style="height:150px;" :options="bar_opt" :chart-data="detect_data"/>
        </b-col>
        <b-col sm="6" lg="3">
          <h6 class="mb-0">페이지 탐지 룰 분류</h6>
          <card-bar-chart class="chart-wrapper px-3" style="height:150px;" :options="bar_opt" :chart-data="result_data"/>
        </b-col>
        <b-col sm="6" lg="3">
          <h6 class="mb-0">탐지 룰</h6>
          <card-bar-chart class="chart-wrapper px-3" style="height:150px;" :options="bar_opt" :chart-data="rule_data"/>
        </b-col>
      </b-row>
      </b-card>
      <b-card>
      <template slot="header">
         &lt;표 6. 점검 통계표&gt;
      </template>
        <div style="width:100%; min-height: .01%; display: block;">
            <table style="width:100%; max-width:100%; margin-bottom:20px; border-spacing: 0; border-collapse: collapse; border: 1px solid; text-align:center;">
              <tbody>
                <tr style="padding: 4px; background-Color: #ccc text-align: center;">
                  <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">등록 도메인</th>
                  <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">페이지 점검 건수</th>
                  <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">페이지 탐지 룰 분류</th>
                  <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">탐지 룰</th>
                </tr>
                <tr style="padding: 4px; background-Color: #ccc text-align: center;">
                  <td style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;" v-if="this.site.is_use"><b>( 총 : {{site.is_use + site.un_use}}건)</b></td>
                  <td style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;" v-if="!this.site.is_use"><b>( 총 : 0 건)</b></td>
                  <td style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;"><b>( 총 : {{result.total.page_count + result.total.ext_count + result.total.detect_count}} 건)</b></td>
                  <td style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">
                    <b>( 총 :  건)</b>
                  </td>
                  <td style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;"><b>( 총 : {{ model.rs_rule && model.rs_rule[0].U + model.rs_rule[0].S + model.rs_rule[0].M + model.rs_rule[0].R|number}} 건)</b></td>
                </tr>
                <tr class="right2">
                  <td style="border: 1px solid;" v-if="site.is_use">[사용중 : {{site.is_use}} 건]</td>
                  <td style="border: 1px solid;">[내부 페이지  : {{result.total.page_count}} 건]</td>
                  <td style="border: 1px solid;">[]</td>
                  <td style="border: 1px solid;">[]</td>
                </tr>
                <tr class="right2">
                  <td style="border: 1px solid;">[미사용 : {{site.un_use}} 건]</td>
                  <td style="border: 1px solid;">[외부 페이지 : {{result.total.ext_count}} 건]</td>
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                </tr>
                <tr class="right2">
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;">[탐지 페이지 : {{result.total.detect_count}} 건]</td>
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                </tr>
                <tr class="right2">
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                </tr>
                <tr class="right2">
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                </tr>
                <tr class="right2">
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                </tr>
              </tbody>
            </table>
          </div>
      </b-card>



      <!-- 표.9 -->

    </div>
</template>

<script>

import { idle } from '@/service';
import CardBarChart from '../report/CardBarChart';
import moment from 'moment-timezone';
import datepicker from '@/custom';
import DatePicker from 'vue2-datepicker';
import MainChart from '../report/MainChart';
import { Api } from '@/service';
import { code } from '@/codes';


const default_opt = () => ({
  perPage: 10,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: true
});
let use_dataset = {
  labels: ['사용중', '미사용'],
  datasets: [{
      label: '도메인',
      backgroundColor: 'rgba(255,0,0,.3)',
      borderColor: 'transparent',
      data: []
    }]
}
let detect_dataset = {
  labels: ['내부패이지', '외부페이지', '탐지페이지'],
  datasets: [{
      label: '탐지 건수',
      backgroundColor: 'rgba(255,0,0,.3)',
      borderColor: 'transparent',
      data: []
    }]
}
let result_dataset = {
  labels: ['URL', '문자열', 'MD5', '정규식'],
  datasets: [{
      label: '점검 분류',
      backgroundColor: 'rgba(255,0,0,.3)',
      borderColor: 'transparent',
      data: []
    }]
}
let rule_dataset = {
  labels: ['URL', '문자열', 'MD5', '정규식'],
  datasets: [{
      label: '탐지룰 수',
      backgroundColor: 'rgba(255,0,0,.3)',
      borderColor: 'transparent',
      data: [78, 81, 80, 45]
    }]
}
const bar_opt = {
  maintainAspectRatio: false,
  legend: { display: false },
  scales: {
    xAxes: [{ display: true, categoryPercentage: 1, barPercentage: 0.5 }],
    yAxes: [{ display: true }]
  }
};
const line_opt = {
  maintainAspectRatio: false,
      legend: {
        display: true
      },
      scales: {
        xAxes: [{
          gridLines: {
            drawOnChartArea: true
          }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: false,
            maxTicksLimit: 7,
            stepSize: Math.ceil(2000 / 5),
            max: 2000
          },
          gridLines: {
            display: true
          }
        }]
      },
      elements: {
        point: {
          radius: 5,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3
        }
      }
}
const line_opt2 = {
  maintainAspectRatio: false,
      legend: {
        display: true
      },
      scales: {
        xAxes: [{
          gridLines: {
            drawOnChartArea: true
          }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: false,
            maxTicksLimit: 7,
            stepSize: Math.ceil(20000 / 5),
            max: 20000
          },
          gridLines: {
            display: true
          }
        }]
      },
      elements: {
        point: {
          radius: 5,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3
        }
      }
}
export default {
  components: { DatePicker, MainChart, CardBarChart },
  data: () => {
    return {
      user : '',
      From: '',
      To: '',
      TT: '',
      FD: '',
      TD: '',
      model:{},
      bar_opt : bar_opt,
      line_opt : line_opt,
      line_opt2 : line_opt2,
      // site_status : site_status,
      rs_ch9 : [],
      rs_ch11 : [],
      rs_ch7 : [],
      rs_ch8 : [],
      rs_ch12 : [],
      rs_ch10 : [],
      rs_ch5 : [],
      use_data : null,
      result_data : null,
      detect_data : null,
      rule_data : null,
      image2_data : null,
      image3_data : null,
      image4_data : null,

      detect : {
        summary : {
          H : 0,
        }
      },
      pattern : undefined,
      result : { total : 0 },
      site : { is_use : 0, un_use : 0},


      lan: datepicker,
      so : default_opt()
    }
  },
  computed: {
    ch7 : function(){ return[
        { key: 'id', label: 'No.', thStyle: 'width: 10%' },
        { key: 'name', label: '사이트명' },
        { key: 'fqdn', label: 'FQDN' },
        { key: 'result', label: '점검결과' },
        { key: 'page_count', label: '페이지수' },
        { key: 'started_at', label: '점검시작' },
        { key: 'ended_at', label: '점검종료' },
      ]
    },
    ch8 : function(){ return[
        { key: 'index', label: 'No.', thStyle: 'width: 10%' },
        { key: 'Date', label: 'Date' },
        { key: 'T', label: '점검도메인' },
      ]
    },
    ch9 : function(){ return[
        { key: 'index', label: 'No.'},
        { key: 'Date', label: 'Date' },
        { key: 'H', label: '위험' },
        { key: 'N', label: '의심' },
        { key: 'S', label: '주의' },
        { key: 'W', label: '경고' },
        { key: 'T', label: '총' },
      ]
    },
    ch10 : function(){ return[
        { key: 'name', label: '사이트명' },
        { key: 'fqdn', label: 'URL' },
        { key: 'info', label: 'Code' },
        { key: 'level', label: '위험등급' },
        { key: 'Date', label: '점검일자' },
      ]
    },
    ch11 : function(){ return[
        { key: 'index', label: 'No.', thStyle: 'width: 10%' },
        { key: 'Date', label: 'Date' },
        { key: 'S', label: '의심' },
        { key: 'W', label: '경고' },
        { key: 'H', label: '위험' },
        { key: 'N', label: '주의' },
        { key: 'G', label: '좋음' },
        { key: 'E', label: '에러' },
      ]
    },
    ch12 : function(){ return[
        { key: 'name', label: '사이트명' },
        { key: 'fqdn', label: 'URL' },
        { key: 'info', label: 'Code' },
        { key: 'level', label: '위험등급' },
        { key: 'Date', label: '점검일자' },
      ]
    },
    ch5 : function() { return [
        { key: 'domain', label: '사이트명' },
        { key: 'task_key', label: '키' },
        { key: 'type', label: '룰' },
        { key: 'detected_at', label: '탐지날짜' }
      ]
    },
    startRow : function() {
      return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage;
    }
  },
  methods: {
    printNow(value){
      this.print = value;
      this.$nextTick(() => {
      window.print();
      });
    },
    report(){
      let m = {from : moment(this.From).format('YYYY-MM-DD'), to : moment(this.To).format('YYYY-MM-DD') }
        return Api.WMDS({target: 'report', cmd: 'data', body : m, limit: 50 }).then(rs => {


          this.user = rs.body.user.username;
          this.detect = rs.body.detect;
          this.result = rs.body.result;
          this.pattern = rs.body.pattern;
          this.site = rs.body.site;
          // this.rs_ch5 = rs.body.detect.data

          use_dataset.labels = ['사용중', '미사용']
          use_dataset.datasets[0].data = [];

          use_dataset.datasets[0].data[0] = rs.body.site.is_use;
          use_dataset.datasets[0].data[1] = rs.body.site.un_use;
          this.use_data = _.cloneDeep(use_dataset);

          console.log(rs.body);
          detect_dataset.labels = ['내부페이지', '외부페이지', '탐지페이지']
          detect_dataset.datasets[0].data[0] = rs.body.result.total.page_count
          detect_dataset.datasets[0].data[1] = rs.body.result.total.ext_count
          detect_dataset.datasets[0].data[2] = rs.body.result.total.detect_count
          // detect_dataset.datasets[0].data.push(rs.body.result.total.page_count)
          this.detect_data = _.cloneDeep(detect_dataset);

          result_dataset.labels = ['URL', '문자열', 'MD5', '정규식']
          result_dataset.datasets[0].data[0] = rs.body.detect.total.U
          result_dataset.datasets[0].data[1] = rs.body.detect.total.S
          result_dataset.datasets[0].data[2] = rs.body.detect.total.H
          result_dataset.datasets[0].data[3] = rs.body.detect.total.R
          this.result_data = _.cloneDeep(result_dataset);

        rule_dataset.labels = ['URL', '문자열', 'MD5', '정규식']
        rule_dataset.datasets[0].data = _.map(rs.rs_rule, 'W');
        rule_dataset.datasets[0].data[1] = _.map(rs.rs_rule, 'S');
        rule_dataset.datasets[0].data[2] = _.map(rs.rs_rule, 'M');
        rule_dataset.datasets[0].data[3] = _.map(rs.rs_rule, 'R');
        this.rule_data = _.cloneDeep(rule_dataset);

        // this.image2_data = { labels: rs.rs_result3.map(rs => rs.Date),
        //   datasets: [{ label: '점검도메인', backgroundColor: 'transparent', borderColor: '#00D8FF', pointHoverBackgroundColor: '#fff', data: rs.rs_result3.map(rs => rs.T) }]}

        // this.image3_data = { labels: rs.rs_ch9.map(rs => rs.Date),
        //   datasets: [
        //     { label: '의심', backgroundColor: 'transparent', borderColor: '#FF0000', pointHoverBackgroundColor: '#fff', data: rs.rs_ch9.map(rs => rs.S) },
        //     { label: '경고', backgroundColor: 'transparent', borderColor: '#FF5E00', pointHoverBackgroundColor: '#fff', data: rs.rs_ch9.map(rs => rs.W) },
        //     { label: '위험', backgroundColor: 'transparent', borderColor: '#FFBB00', pointHoverBackgroundColor: '#fff', data: rs.rs_ch9.map(rs => rs.H) },
        //     { label: '주의', backgroundColor: 'transparent', borderColor: '#FFE400', pointHoverBackgroundColor: '#fff', data: rs.rs_ch9.map(rs => rs.N) }]
        // }

        // this.image4_data = { labels: rs.rs_result2.map(rs => rs.Date),
        //     datasets: [
        //       { label: '의심', backgroundColor: 'transparent', borderColor: '#FF0000', pointHoverBackgroundColor: '#fff', data: rs.rs_result2.map(rs => rs.S) },
        //       { label: '경고', backgroundColor: 'transparent', borderColor: '#FF5E00', pointHoverBackgroundColor: '#fff', data: rs.rs_result2.map(rs => rs.W) },
        //       { label: '위험', backgroundColor: 'transparent', borderColor: '#FFBB00', pointHoverBackgroundColor: '#fff', data: rs.rs_result2.map(rs => rs.H) },
        //       { label: '주의', backgroundColor: 'transparent', borderColor: '#FFE400', pointHoverBackgroundColor: '#fff', data: rs.rs_result2.map(rs => rs.N) },
        //       { label: '좋음', backgroundColor: 'transparent', borderColor: '#00D8FF', pointHoverBackgroundColor: '#fff', data: rs.rs_result2.map(rs => rs.G) },
        //       { label: '오류', backgroundColor: 'transparent', borderColor: '#EAEAEA', pointHoverBackgroundColor: '#fff', data: rs.rs_result2.map(rs => rs.E) },]
        // }
        this.model = rs.body;
        // this.rs_ch9 = rs.rs_ch9;
        // this.rs_ch11 = rs.rs_result2;
        // this.rs_ch8 = rs.rs_result3;
        // this.rs_ch12 = rs.rs_s_result;
        // this.rs_ch10 = rs.rs_wnh_result;
        this.rs_ch7.push(rs.body.result.data);
        this.rs_ch5.push(rs.body.detect.data);

        return this.model;
      })

      .then(() => {
        if(this.$refs._ch5) {
          this.$refs._ch5.refresh(); //표5
          this.$refs._ch7.refresh(); //표7
        //   this.$refs._ch8.refresh(); //표8
        //   this.$refs._ch9.refresh(); //표9
        //   this.$refs._ch10.refresh(); //표10
        //   this.$refs._ch11.refresh(); //표11
        //   this.$refs._ch12.refresh(); //표12
        }
      })
      .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    reset() { this.refresh(); },
    hideList: function(e) {
      this.show = !e; console.log('report.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
    }
  },
  created: function() { console.log('report.vue', 'created'); },
  destroyed: function() {
    console.log('report.vue', 'destroyed');
  },
  mounted: function() {
    this.From = moment().format('YYYY-MM-DD');
    this.To = moment().format('YYYY-MM-DD');
    this.report();
    console.log('report.vue', 'mounted'); },
}
</script>
